module.exports = __webpack_public_path__ + "assets/img/isv_2.5058ce77.png";